import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '.';

export type ClientSettingsState = {
  themeName: string;
  isToggleSidebarOpen: boolean;
};

export const initialState: ClientSettingsState = {
  themeName: localStorage.getItem('app-theme'),
  isToggleSidebarOpen: false,
};

const clientSettingsSlice = createSlice({
  name: 'clientSettings',
  initialState,
  reducers: {
    setThemeName: (state, action) => {
      state.themeName = action.payload;
    },
    toggleSidebar: (state) => {
      state.isToggleSidebarOpen = !state.isToggleSidebarOpen;
    },
  },
});

export const { setThemeName, toggleSidebar } = clientSettingsSlice.actions;

// export clientSettings selector to get the slice in any component
export const clientSettingsSelector = (state: RootState) => state.clientSettings;
// export The reducer
const clientSettingsReducer = clientSettingsSlice.reducer;
export default clientSettingsReducer;
